export const BookmarkPaginationSettings = {
    AccordionTake: 10,
    DefaultViewAllTake: 10,
    SidebarTake: 10,
};
